import { Link } from "react-router-dom";

function FooterLink(props) {
    return (
        <li>
            <Link to={props.href}>{props.name}</Link>
        </li>
    );
}

export default function Footer() {
    return (
        <footer>
            <div className="container">
                <div className="fbody">
                    <div className="columns">
                        <ul className="column">
                            <h3>Приватный сервер</h3>
                            <FooterLink href="/leaders" name="Топ игроков" />
                            {/* <FooterLink href="/roulette" name="Рулетка уровней" /> */}
                            <FooterLink href="https://t.me/yargogdpsnews" name="Новости" />
                            <FooterLink href="https://gofruit.space/gdps/053m" name="Скачать" />
                        </ul>
                        <ul className="column">
                            <h3>Соц. Сети</h3>
                            <FooterLink href="https://discord.gg/EE2DtycSdz" name="Дискорд" />
                            <FooterLink href="https://t.me/YarGoYT" name="Телеграм" />
                            <FooterLink href="https://www.youtube.com/channel/UCpW4IahRt0f7BKJ0XiN2-gg" name="Ютуб" />
                        </ul>
                        <ul className="column">
                            <h3>Команда</h3>
                            <FooterLink href="/team" name="О нас" />
                            <FooterLink href="https://github.com/shizuketsu" name="GitHub" />
                        </ul>
                    </div>
                    <div className="copyright">
                        <h3>YarGo © 2024</h3>
                    </div>
                </div>
            </div>
        </footer>
    );
}